const items = [
	{
		id: 1,
		status: 1,
		name: "statusInsurance.active"
	},
	{
		id: 2,
		status: 2,
		name: "statusInsurance.inActive"
	},
	{
		id: 3,
		status: -1,
		name: "statusInsurance.expired"
	},
	{
		id: 4,
		status: 3,
		name: "statusInsurance.inDebt"
	}, {
		id: 5,
		status: 4,
		name: "statusInsurance.noDebt"
	}
];

export default items;